import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
    name: "auth",
    initialState: {
        currentUser: null, // null atau object berisi data user
        isGuest: null,
        userRoles: [],
    },
    reducers: {
        setIsGuest: (state, action) => {
            state.isGuest = action.payload.isGuest;
            if (action.payload.isGuest) {
                state.currentUser = null;
            }
        },
        setCurrentUser: (state, action) => {
            state.currentUser = action.payload.currentUser;
            if (action.payload.currentUser === null) {
                state.isGuest = true;
            }
        },
        setUserRoles: (state, action) => {
            state.userRoles = action.payload.userRoles;
        },
    }
});

export const { setCurrentUser, setIsGuest, setUserRoles } = authSlice.actions;

export default authSlice.reducer;